import store from '@/store'
import User from '@model/User.js'

export function _resolvePatientJourneyListColumnOfType_ptUser(column, patientJourney, row, errors, isGoddard) {
    if (isGoddard && row[column.id]) {
        const userData = row[column.id]

        if (userData.titledFullName) {
            column.cellText = userData.titledFullName
        } else {
            // todo: remove this else block when MSK-16432 is complete
            const user = new User(userData)
            if (user?.titledFullName) {
                column.cellText = user.titledFullName
            }
        }
    }

    if (row.ptClinicianId) {
        const user = store.state.user.users[row.ptClinicianId]

        if (user) {
            column.ptUser = user
            column.cellText = user.titledFullName
        }
    }
}
